import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
import {ReportComponentDefinitionModel} from "../../../api/entity/reportComponentDefinition.model";
import {ReportComponentDefinitionConverter} from "../../../api/entity/converter/reportComponentDefinition.converter";

@Injectable()
export class ReportComponentDefinitionDataService extends AbstractDataServiceV2<ReportComponentDefinitionModel, ReportComponentDefinitionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: ReportComponentDefinitionConverter) {
        super('ReportComponentDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
